// hooks/usePayablePdf.ts

import PayablePdfService from "../../services/pdf/payablePdf.service";
import useLoading from "../useLoading";

export const usePayablePdf = () => {
    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    /**
     * 📄 Descargar estado de cuenta PDF
     */
    const handleDownloadPayablePdf = async (
        PayableId: number
    ) => {

        try {
            showLoadingIndicator();

            const { blob, fileName } =
                await PayablePdfService.download(
                    PayableId
                );

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download =
                fileName ||
                `estado_cuenta_${PayableId}.pdf`;

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error(
                "❌ Error descargando PDF de cuenta por pagar:",
                error
            );
        } finally {
            hideLoadingIndicator();
        }
    };

    return {
        handleDownloadPayablePdf,
    };
};

export default usePayablePdf;